import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  height: 95%;
  overflow-y: auto;
`;

export const FieldRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
`;

export const FieldSet = styled.fieldset`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 5px;
  width: ${({ $width }) => $width};
  height: 100%;

  border: none;
`;

export const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  height: ${({ $height }) => $height || 'content-fit'} !important;
  padding-top: 10px;

  & + div {
    border-top: 1px solid #ddd;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 25px;

  width: 100%;

  span {
    font-weight: 500;
    font-size: 1rem;
  }
`;

export const EnableEMRConfig = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
`;

export const WrapperButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: -8px;
`;
